import { render, staticRenderFns } from "./ViqLensIcon.vue?vue&type=template&id=b7cefc4e"
import script from "./ViqLensIcon.vue?vue&type=script&lang=js"
export * from "./ViqLensIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7cefc4e')) {
      api.createRecord('b7cefc4e', component.options)
    } else {
      api.reload('b7cefc4e', component.options)
    }
    module.hot.accept("./ViqLensIcon.vue?vue&type=template&id=b7cefc4e", function () {
      api.rerender('b7cefc4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqLensIcon.vue"
export default component.exports